import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ApiError } from '@koridor/api-client';
import { parseAppleCallback } from '../lib/apple-signin';
import { LoadingOverlay } from '../components/LoadingOverlay';

function readCallbackPayload() {
  const hash = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : '';
  const search = window.location.search.startsWith('?') ? window.location.search.slice(1) : '';
  return parseAppleCallback(hash || search);
}

function waitForHash(ms = 50): Promise<void> {
  return new Promise((resolve) => {
    requestAnimationFrame(() => setTimeout(resolve, ms));
  });
}

export function AppleCallbackScreen() {
  const navigate = useNavigate();
  const { appleLogin } = useAuth();
  const appleLoginRef = useRef(appleLogin);
  appleLoginRef.current = appleLogin;
  const processedRef = useRef(false);
  const [phase, setPhase] = useState<'loading' | 'error'>('loading');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;

    (async () => {
      let result = readCallbackPayload();
      if (!result) {
        await waitForHash();
        result = readCallbackPayload();
      }
      if (!result) {
        setPhase('error');
        setError('Не удалось получить данные от Apple');
        return;
      }
      try {
        await appleLoginRef.current(result.identityToken, result.nickname);
        navigate('/', { replace: true });
      } catch (err) {
        setPhase('error');
        setError(err instanceof ApiError ? err.message : 'Ошибка входа');
      }
    })();
  }, [navigate]);

  if (phase === 'error' && error) {
    return (
      <div style={{
        minHeight: '100dvh', background: 'var(--bg-app)', boxSizing: 'border-box',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        padding: '40px var(--gutter)', textAlign: 'center',
      }}>
        <p style={{ color: 'var(--danger)', marginBottom: 16 }}>{error}</p>
        <a href="/auth" style={{ color: 'var(--text-accent)', fontWeight: 600 }}>Вернуться к входу</a>
      </div>
    );
  }

  return <LoadingOverlay fixed label="Вход через Apple…" />;
}
